import React from "react";
import { Toast } from "react-bootstrap";

const ToasterMessage = ({ show, message, onClose }) => {
  return (
    <Toast show={show} onClose={onClose}  bg="success">
      <Toast.Header>
        <strong className="me-auto">Toaster Message</strong>
      </Toast.Header>
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  );
};

export default ToasterMessage;
